<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapActions, mapGetters } from "vuex";
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import {swal} from '../../../helpers/handle_error.js';
import AlertError from '@/components/alert_error'
import Quotation from '../../../model/quotation.js';
import { VueContentLoading } from 'vue-content-loading';

export default {
  page: {
    title: "الاقتباس",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, AlertError,  VueContentLoading },
  data() {
    return {
     
      title: "الاقتباس",
      items: [
        {
          text: "الرئيسية",
          href: "/",
        },
        {
          text: "الاقتباس",
          active: true,
        },
      ],

      //Page errors.
      errors: [],

      id: this.$route.params.id,
      quotation: new Quotation,

      submitadd: false,
      loadingButton: false,
      loadingContent: false
    };
  },
  validations: {
    quotation: {
      title_ar: {required, minLength: minLength(2), maxLength: maxLength(100) },
      title_en: {required, minLength: minLength(2), maxLength: maxLength(100) },
      title_fa: {required, minLength: minLength(2), maxLength: maxLength(100) },
      description_ar: {required, minLength: minLength(5), maxLength: maxLength(400) },
      description_en: {required, minLength: minLength(5), maxLength: maxLength(400) },
      description_fa: {required, minLength: minLength(5), maxLength: maxLength(400) },
    },  
  },
  computed:{
    ...mapGetters('quotation', ['getQuotation'])
  },
  methods: {
    ...mapActions("quotation", ['getAll', 'edit']),
    handleError(error){
      if(error.response.status == 422) this.errors = Object.values(error.response.data.errors)
      else this.errors = [`Error Code : ${error.response.status}  Message : ${error.response.data.message}`]
    },
    resetForm(){
      this.submitadd = false
      this.loadingButton = false
      this.errors = []
    },
    formEditQuotation() {
      this.submitadd = true;
      this.$v.$touch();
      if(this.$v.$error) return;

      // to form submit after this
      this.loadingButton = true
      this.errors = [];
      
      this.edit({
        id: this.quotation.id,
        quotation: this.quotation.toFormData()
      }).then((response)=>{
        swal.success(response.data.message)
        this.resetForm()
      })
      .catch((error)=>{
        alert(error)
        this.handleError(error)
        this.loadingButton = false
      })
    },
  },
  created(){
    this.getAll()
    .then(()=>{
      this.quotation = this.getQuotation
      this.loadingContent = true
    })
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">

            <b-form v-if="loadingContent" @submit.prevent="formEditQuotation()">

              <AlertError :errors="errors"></AlertError>

              <div class="row mt-3">

                <b-form-group class="col-md-12 mb-3" label="عنوان الاقتباس : ( عربي )" label-for="title_ar" >
                  <b-form-input id="title_ar" v-model.trim="quotation.title_ar" :class="{ 'is-invalid': submitadd && $v.quotation.title_ar.$error }" placeholder="ادخل عنوان الاقتباس" type="text" ></b-form-input>
                  <div v-if="submitadd && $v.quotation.title_ar.$error" class="invalid-feedback">
                    <span v-if="!$v.quotation.title_ar.required"> هذا الحقل الزامي </span>
                    <span v-if="!$v.quotation.title_ar.minLength"> قيمة هذا الحقل قصيرة جداً. يجب ان يتكون من 2 احرف على الاقل . </span>
                    <span v-if="!$v.quotation.title_ar.maxLength"> قيمة هذا الحقل طويلة جداً. يجب ان يتكون من 100 حرف على الاكثر . </span>
                  </div>
                </b-form-group>

                <b-form-group class="col-md-12 mb-3" label="وصف الاقتباس : ( عربي )" label-for="description_ar" >
                  <textarea id="description_ar" class="form-control" v-model.trim="quotation.description_ar" :class="{ 'is-invalid': submitadd && $v.quotation.description_ar.$error }" name="textarea" rows="5" placeholder="ادخل محتوى الاقتباس"></textarea>
                  <div v-if="submitadd && $v.quotation.description_ar.$error" class="invalid-feedback">
                    <span v-if="!$v.quotation.description_ar.required"> هذا الحقل الزامي </span>
                    <span v-if="!$v.quotation.description_ar.minLength"> قيمة هذا الحقل قصيرة جداً. يجب ان يتكون من 5 احرف على الاقل . </span>
                    <span v-if="!$v.quotation.description_ar.maxLength"> قيمة هذا الحقل طويلة جداً. يجب ان يتكون من 400 حرف على الاكثر . </span>
                  </div>
                </b-form-group>

                <b-form-group class="col-md-12 mb-3" label="عنوان الاقتباس : ( انجليزي )" label-for="title_en" >
                  <b-form-input id="title_en" v-model.trim="quotation.title_en" :class="{ 'is-invalid': submitadd && $v.quotation.title_en.$error }" placeholder="ادخل عنوان الاقتباس" type="text" ></b-form-input>
                  <div v-if="submitadd && $v.quotation.title_en.$error" class="invalid-feedback">
                    <span v-if="!$v.quotation.title_en.required"> هذا الحقل الزامي </span>
                    <span v-if="!$v.quotation.title_en.minLength"> قيمة هذا الحقل قصيرة جداً. يجب ان يتكون من 2 احرف على الاقل . </span>
                    <span v-if="!$v.quotation.title_en.maxLength"> قيمة هذا الحقل طويلة جداً. يجب ان يتكون من 100 حرف على الاكثر . </span>
                  </div>
                </b-form-group>

                <b-form-group class="col-md-12 mb-3" label="وصف الاقتباس : ( انجليزي )" label-for="description_en" >
                  <textarea id="description_en" class="form-control" v-model.trim="quotation.description_en" :class="{ 'is-invalid': submitadd && $v.quotation.description_en.$error }" rows="5" placeholder="ادخل محتوى الاقتباس"></textarea>
                  <div v-if="submitadd && $v.quotation.description_en.$error" class="invalid-feedback">
                    <span v-if="!$v.quotation.description_en.required"> هذا الحقل الزامي </span>
                    <span v-if="!$v.quotation.description_en.minLength"> قيمة هذا الحقل قصيرة جداً. يجب ان يتكون من 5 احرف على الاقل . </span>
                    <span v-if="!$v.quotation.description_en.maxLength"> قيمة هذا الحقل طويلة جداً. يجب ان يتكون من 400 حرف على الاكثر . </span>
                  </div>
                </b-form-group>

                <b-form-group class="col-md-12 mb-3" label="عنوان الاقتباس : ( فارسي )" label-for="title_fa" >
                  <b-form-input id="title_fa" v-model.trim="quotation.title_fa" :class="{ 'is-invalid': submitadd && $v.quotation.title_fa.$error }" placeholder="ادخل عنوان الاقتباس" type="text" ></b-form-input>
                  <div v-if="submitadd && $v.quotation.title_fa.$error" class="invalid-feedback">
                    <span v-if="!$v.quotation.title_fa.required"> هذا الحقل الزامي </span>
                    <span v-if="!$v.quotation.title_fa.minLength"> قيمة هذا الحقل قصيرة جداً. يجب ان يتكون من 2 احرف على الاقل . </span>
                    <span v-if="!$v.quotation.title_fa.maxLength"> قيمة هذا الحقل طويلة جداً. يجب ان يتكون من 100 حرف على الاكثر . </span>
                  </div>
                </b-form-group>

                <b-form-group class="col-md-12 mb-3" label="وصف الاقتباس : ( فارسي )" label-for="description_fa" >
                  <textarea id="description_fa" class="form-control" v-model.trim="quotation.description_fa" :class="{ 'is-invalid': submitadd && $v.quotation.description_fa.$error }" name="textarea" rows="5" placeholder="ادخل محتوى الاقتباس"></textarea>
                  <div v-if="submitadd && $v.quotation.description_fa.$error" class="invalid-feedback">
                    <span v-if="!$v.quotation.description_fa.required"> هذا الحقل الزامي </span>
                    <span v-if="!$v.quotation.description_fa.minLength"> قيمة هذا الحقل قصيرة جداً. يجب ان يتكون من 5 احرف على الاقل . </span>
                    <span v-if="!$v.quotation.description_fa.maxLength"> قيمة هذا الحقل طويلة جداً. يجب ان يتكون من 400 حرف على الاكثر . </span>
                  </div>
                </b-form-group>

              </div>

              <div class="mt-3">
                <hr>
                <b-button :disabled="loadingButton" variant="primary" type="submit" class="me-2"> 
                  <b-spinner v-if="loadingButton" small></b-spinner>
                  <span v-else><i class="bx bx-check font-size-16 align-middle me-2"></i>حفظ التعديلات</span>
                </b-button>
              </div>
            </b-form>

            <!-- loading content -->
            <div v-else>
              <vue-content-loading :rtl="true" :width="400" :height="217">
                <rect  x="0" y="4" rx="1" ry="1" width="50" height="2" />
                <rect x="0" y="8" rx="1" ry="1" width="400" height="10" />
                <rect x="0" y="23" rx="1" ry="1" width="50" height="2" />
                <rect x="0" y="27" rx="1" ry="1" width="400" height="35" />
                <rect x="0" y="67" rx="1" ry="1" width="50" height="2" />
                <rect x="0" y="71" rx="1" ry="1" width="400" height="10" />
                <rect x="0" y="86" rx="1" ry="1" width="50" height="2" />
                <rect x="0" y="90" rx="1" ry="1" width="400" height="35" />
                <rect x="0" y="130" rx="1" ry="1" width="50" height="2" />
                <rect x="0" y="134" rx="1" ry="1" width="400" height="10" />
                <rect x="0" y="149" rx="1" ry="1" width="50" height="2" />
                <rect x="0" y="154" rx="1" ry="1" width="400" height="35" />
                <rect x="0" y="198" rx="1" ry="1" width="400" height="1" />
                <rect x="0" y="203" rx="1" ry="1" width="35" height="10" />
              </vue-content-loading>
            </div>

            

          </div>
        </div>
      </div>

    </div>

  </Layout>
</template>